import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@opus/utils';
// utility classes, not app css: apps' tailwind `content` scans this package (no per-app copies to drift)
export function Spinner({ className, label = 'loading' }) {
    return (_jsx("span", { role: "status", "aria-label": label, className: cn('inline-block h-6 w-6 animate-spin rounded-full border-2 border-border border-t-[var(--accent-primary)] motion-reduce:animate-none', className) }));
}
export function Skeleton({ className }) {
    return _jsx("div", { "aria-hidden": true, className: cn('animate-pulse rounded-md bg-muted motion-reduce:animate-none', className) });
}
//# sourceMappingURL=spinner.js.map